import React from "react";

const Modal = (props) => {
  return (
    <div className="overlay">
      <div
        className="outline"
        onClick={() => {
          props.Close();
        }}
      ></div>
      <div className="skill-modal-body metrics-modal">
        <section className="modal-head">
          <h1>
              {props.ShowIcon ? <i className='feather-info'/> : null}
              {props.Data.section + ": " + props.Data.row}
          </h1>
          <i
            className="feather-x"
            onClick={() => {
              props.Close();
            }}
          ></i>
        </section>
        <main className="main-content-holder main-content-flex">
          <p className="modal-info-text">{props.Text}</p>
        </main>
      </div>
    </div>
  );
};

export default Modal;
